<template>
  <i
    :id="id"
    class="app-icon"
    :class="rootClass"
  />
</template>

<script>
import { defineComponent } from 'vue'
import { v4 as uuidv4 } from 'uuid'

export default defineComponent({
  name: 'AppIcon',

  props: {
    id: {
      type: String,
      default: () => uuidv4()
    },
    color: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: ''
    },
    strong: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    rootClass () {
      return [
        this.colorClass,
        this.iconClass,
        this.sizeClass,
        this.strongClass
      ]
    },
    colorClass () {
      if (this.colors.includes(this.color)) {
        return `app-icon--${this.color}`
      }

      return 'app-icon--primary'
    },
    iconClass () {
      if (this.icon.indexOf('mdi') >= 0) {
        return `mdi ${this.icon}`
      }
      return this.icon
    },
    sizeClass () {
      if (this.sizes.includes(this.size)) {
        return `app-icon--${this.size}`
      }

      return ''
    },
    strongClass () {
      return this.strong ? 'app-icon--strong' : ''
    }
  },

  setup () {
    return {
      colors: ["black", "gray", "white", "primary"],
      sizes: ["xlarge", "large"]
    }
  },
})
</script>

<style lang="scss" scoped>
.app-icon {
  align-items: center;
  color: $base-color;
  display: inline-flex;
  justify-content: center;

  &:not(:first-child) {
    margin-left: .5rem;
  }

  &:not(:last-child) {
    margin-right: .5rem;
  }
  
  &:before {
    font-size: 1rem;
  }

  &--primary {
    color: $primary-color;
  }

  &--gray {
    color: $base-background-gray;
  }

  &--white {
    color: $primary-color-inverted;
  }
  
  &--strong {
    &:before {
      font-weight: 700;
    }
  }

  &--large {
    &.mdi:before {
      font-size: 1.5rem;
    }
  }

  &--xlarge {
    &.mdi:before {
      font-size: 2rem;
    }
  }
}
</style>
